function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bb_active_svg__cls-2{fill:#6cff00}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bb_active_svg__Group_21650",
  transform: "translate(.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "bb_active_svg__Rectangle_7812",
  fill: "none",
  stroke: "#6cff00",
  strokeDasharray: "1 1"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h14v14H0z",
  transform: "translate(.999 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h13v13H.5z",
  transform: "translate(.999 1)"
})), /*#__PURE__*/React.createElement("circle", {
  id: "bb_active_svg__Ellipse_685",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "bb_active_svg__cls-2",
  transform: "translate(-.001)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "bb_active_svg__Ellipse_686",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "bb_active_svg__cls-2",
  transform: "translate(12.999 13)"
}));
function SvgBbActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "bb_active_svg__Component_119_173",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Component_119_173' width='16' height='16' viewBox='0 0 16 16'%3e %3cdefs%3e %3cstyle%3e .cls-2%7bfill:%236cff00%7d %3c/style%3e %3c/defs%3e %3cg id='Group_21650' transform='translate(.001)'%3e %3cg id='Rectangle_7812' fill='none' stroke='%236cff00' stroke-dasharray='1 1'%3e %3cpath stroke='none' d='M0 0H14V14H0z' transform='translate(.999 1)'/%3e %3cpath d='M0.5 0.5H13.5V13.5H0.5z' transform='translate(.999 1)'/%3e %3c/g%3e %3ccircle id='Ellipse_685' cx='1.5' cy='1.5' r='1.5' class='cls-2' transform='translate(-.001)'/%3e %3ccircle id='Ellipse_686' cx='1.5' cy='1.5' r='1.5' class='cls-2' transform='translate(12.999 13)'/%3e %3c/g%3e %3c/svg%3e";
export { SvgBbActive as ReactComponent };